import "./main.css"
import Header from "../../components/header/header";
import { usePumpStore } from "../../store/pumpStore";
import {TaskScreen} from "../../components/tasks/tasks";
import {useEffect} from "react";
import axios from "axios";
import {Profile} from "../../components/profile/profile";
import {Balance} from "../../components/balance/balance";
import { useInitData } from '@telegram-apps/sdk-react';
import { initMiniApp } from '@telegram-apps/sdk';
import {MyTasks} from "../../components/myTasks/myTasks";
import {TaskForm} from "../../components/form/form";
import {LevelUp} from "../../components/levelUp/levelUp";

export const MainPage = () => {
    const {screen, appInitData, setAppInitData, setUserId, setEquity, setBalance, setTasksCount, setTaskNumber, setLevel, setStatus, setScreenStatus, setTime, screenLayout, setDifficulty, setArtifacts, setActiveCount, setLanguage, setBasePrice, language} = usePumpStore()
    const [miniApp] = initMiniApp();
    const initData = useInitData();
    // const initData = {
    //     user: {
    //         id: 12345
    //     }
    // }


    useEffect(() => {
        miniApp.setHeaderColor('#2F164B');
        miniApp.setBgColor('#2F164B');
        setAppInitData(initData)
        axios.post('https://pump.stt.market/api/fetch_user', {'chat_id': initData.user.id, 'language': language}).then((res) => {
            setUserId(res.data.data.userId)
            setEquity(res.data.data.equity)
            setBalance(res.data.data.balance.toFixed(2))
            setTasksCount(res.data.data.completed)
            setTaskNumber(res.data.data.taskNum)
            setLevel(res.data.data.level)
            setDifficulty(res.data.data.difficulty)
            setArtifacts(res.data.data.artifacts)
            setActiveCount(res.data.data.activeCount)
            setLanguage(res.data.data.language)
            setBasePrice(res.data.data.basePrice)
            if (res.data.data.status === 'locked') {
                setScreenStatus('locked')
                setStatus('wait')
                setTime(res.data.data.timeToOpen)
            }
        })
    }, []);

    return (
        <div className={"main-wrapper"}>
            <Header />
            {screenLayout === 'task' && <TaskScreen />}
            {(screenLayout === 'profile' || screenLayout === 'artifacts') && <Profile />}
            {screenLayout === 'balance' && <Balance />}
            {screenLayout === 'create' && <MyTasks />}
            {screenLayout === 'createForm' && <TaskForm />}
            {screenLayout === 'levelup' && <LevelUp />}
        </div>
    )
}